import EnglishMostFrequentWords from "../assets/Vocab/EnglishMostFrequentWords.json";

const COMMON_WORDS = EnglishMostFrequentWords;

export { COMMON_WORDS };
